/* eslint-disable @typescript-eslint/no-explicit-any */
// src/api/axiosInstance.ts
import { ILoginResponse } from "@src/constants/modals/auth";
import STORAGE_KEYS from "@src/constants/storageKeys";
import axios from "axios";

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL, // Change this to your API
  headers: {
    "Content-Type": "application/json",
  },
});

// Exclude login API from adding Bearer Token
const EXCLUDED_ENDPOINTS = ["/auth/register", "/auth/login", '/otp/resetpassword/generate', '/otp/register/generate', '/auth/reset-password'];

axiosInstance.interceptors.request.use(
  (config) => {
    if (!EXCLUDED_ENDPOINTS.includes(config.url || "")) {
      const { token, user: { id } } = JSON.parse(localStorage.getItem(STORAGE_KEYS.auth_details) ?? "{}") as ILoginResponse;

      //const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOjM4LCJpYXQiOjE3NDUyMjQ0NDgsImV4cCI6MTc0NzgxNjQ0OCwidHlwZSI6ImFjY2VzcyJ9.tHwGnT5PAws5q_SQj1IyYmxzqlGHB1mZ4r-SmJvxo9I'
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
        config.headers.uid = id;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem(STORAGE_KEYS.auth_details);
    }
    return Promise.reject(error);
  }
);

export const getErrorMessage = (error: any) => {
  if (axios.isAxiosError(error)) {
    if (error.response) {
      switch (error.response.status) {
        case 400:
          return error.response.data;
        case 401:
          return error.response.data;
        case 403:
          return error.response.data;
        case 404:
          return error.response.data;
        case 500:
          return error.response.data;
        default:
          return error.response.data;
      }
    } else if (error.request) {
      return 'Network error: No response from server';
    } else {
      return error.message;
    }
  }
  // Handle non-Axios errors
  return error?.message || 'An unknown error occurred';
};
export default axiosInstance;
